import {
  CardContent,
  CardHeader,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  CustomCard,
  LargeGridTexField,
  SmallGridTexField,
} from "./common-components";
import { idCheckErrorMessage, idLogicErrorMessage } from "../../utils/ocr";

export default function OcrForm(props) {
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <>
      <CustomCard>
        <CardHeader title="Kết quả OCR mặt trước" />
        <CardContent>
          <Grid container spacing={mobileScreen ? 1 : 1.75}>
            <SmallGridTexField
              label="Độ đầy đủ"
              id="front_is_full"
              value={
                props.frontCardData.is_full !== undefined
                  ? props.frontCardData.is_full === 1
                    ? "Giấy tờ đầy đủ"
                    : "Giấy tờ không đầy đủ"
                  : ""
              }
            />
            <SmallGridTexField
              label="Trạng thái"
              id="front_id_check"
              value={
                props.frontCardData.id_check
                  ? idCheckErrorMessage[props.frontCardData.id_check]
                  : ""
              }
            />
            <LargeGridTexField
              label="Lỗi logic"
              id="front_id_logic_message"
              value={
                props.frontCardData.id_logic_message
                  ? idLogicErrorMessage[props.frontCardData.id_logic_message]
                  : ""
              }
            />
            <SmallGridTexField
              label="Số CMND"
              id="id"
              value={props.frontCardData.id || ""}
            />
            <SmallGridTexField
              label="Họ và tên"
              id="name"
              value={props.frontCardData.name || ""}
            />
            <SmallGridTexField
              label="Ngày sinh"
              id="birthday"
              value={props.frontCardData.birthday || ""}
            />
            <SmallGridTexField
              label="Giới tính"
              id="sex"
              value={props.frontCardData.sex || ""}
            />
            <LargeGridTexField
              label="Nơi thường trú"
              id="address"
              value={props.frontCardData.address || ""}
            />
            <SmallGridTexField
              label="Mã phường"
              id="precinct_code"
              value={props.frontCardData.precinct_code || ""}
            />
            <SmallGridTexField
              label="Mã quận"
              id="district_code"
              value={props.frontCardData.district_code || ""}
            />
            <SmallGridTexField
              label="Mã tỉnh"
              id="province_code"
              value={props.frontCardData.province_code || ""}
            />
            <SmallGridTexField
              label="Ngày hết hạn"
              id="expiry"
              value={props.frontCardData.expiry || ""}
            />
          </Grid>
        </CardContent>
      </CustomCard>
      <CustomCard>
        <CardHeader title="Kết quả OCR mặt sau" />
        <CardContent>
          <Grid container spacing={mobileScreen ? 1 : 2}>
          <SmallGridTexField
              label="Độ đầy đủ"
              id="back_is_full"
              value={
                props.backCardData.is_full !== undefined
                  ? props.backCardData.is_full === 1
                    ? "Giấy tờ đầy đủ"
                    : "Giấy tờ không đầy đủ"
                  : ""
              }
            />
            <SmallGridTexField
              label="Trạng thái"
              id="back_id_check"
              value={
                props.backCardData.id_check
                  ? idCheckErrorMessage[props.backCardData.id_check]
                  : ""
              }
            />
            <LargeGridTexField
              label="Lỗi logic"
              id="back_id_logic_message"
              value={
                props.backCardData.id_logic_message
                  ? idLogicErrorMessage[props.backCardData.id_logic_message]
                  : ""
              }
            />
            <LargeGridTexField
              label="Cấp bởi"
              id="issue_by"
              value={props.backCardData.issue_by || ""}
            />
            <SmallGridTexField
              label="Ngày cấp"
              id="issue_date"
              value={props.backCardData.issue_date || ""}
            />
            <SmallGridTexField
              label="Dân tộc"
              id="ethnicity"
              value={props.backCardData.ethnicity || ""}
            />
            <SmallGridTexField
              label="Tôn giáo"
              id="religion"
              value={props.backCardData.religion || ""}
            />
          </Grid>
        </CardContent>
      </CustomCard>
    </>
  );
}
